import React from 'react';
import { Input } from 'reactstrap';
import { FieldProps } from 'formik';
import { useAppSelector } from 'src/store/hooks';

interface OwnProps {
  label: string;
  readOnly?: boolean;
}

type Props = OwnProps;

const PromoInput = ({
  label,
  readOnly = false,
  field: { name, onChange, onBlur, value },
  form: { touched, errors },
  ...attributes
}: Props & FieldProps): JSX.Element => {
  const { isFitherProjectUser } = useAppSelector(state => state.signUp);
  const { isPaymentProcessing } = useAppSelector(state => state.payment);

  return (
    <Input
      type="text"
      name={name}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      {...((isFitherProjectUser || isPaymentProcessing || readOnly) && {
        disabled: true,
      })}
      {...attributes}
    />
  );
};

export default PromoInput;
